import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-h-circle', 'LetterHCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9.5 8v4m0 0v4m0-4h5m0-4v4m0 0v4","key":"svg-0"}]]);